import { AxiosAdapter } from '../../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';


export class Service {
	async getCarousel(section, pharmacy, root_pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.MIGRATION_PHAROL}/carousel-product/list/${Enviroment.COUNTRY}`,
			params: { section: section, pharmacy: pharmacy, root_pharmacy: root_pharmacy },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
